import { createRef, Component } from 'react';
import classNames from 'classnames/bind';
import filter from 'lodash-es/filter';
import autoBind from 'react-autobind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import * as authentication from '../../../actions/authentication.actions';

import getPriceInfo from '../helpers/getPriceInfo';

import withComponentName from '../../../decorators/withComponentName';
import withPriceCurrency from '../PriceCurrencyProvider/withPriceCurrency';

import Tooltip from '../../Tooltip';
import PlanItemMobileCard from './PlanItemMobileCard';
import PricingPlanSubscribeOption from '../PricingPlanSubscribeOption';
import Slider from '../../Shared/ReactSlick';

import { GUEST_PLAN } from '../../../data/subscriptionPlans';

import PlanItemMobileStyles from './planItemMobile.module.scss';

const cx = classNames.bind(PlanItemMobileStyles);

class PlanItemMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      slideNum: 1,
    };
    this.slider = createRef();
    autoBind(this);
  }

  setActiveSlide(slideNum) {
    this.setState({
      slideNum,
    }, () => this.slider.current.slickGoTo(slideNum));
  }

  createListElement(featuresList) {
    return featuresList.map((item, index) => (
      <li
        key={index}
        className={item.display_inline ? PlanItemMobileStyles.with_link : ''}
      >
        {item.feature.map((value, index) => (
          <>
            {value instanceof Object && value.href && (
              <a href={value.href} key={index} target="__blank" rel="noreferrer">{value.text}</a>
            )}
            {!(value instanceof Object) && (
              <p
                key={index}
                className={item.display_block ? PlanItemMobileStyles.display_block_text : item.display_inline ? PlanItemMobileStyles.display_inline_text : ''}
              >
                {value}
              </p>
            )}
            {value instanceof Object && value.hasToolTip && (
              <span key={`icon_${index}`} className={PlanItemMobileStyles.plan_tooltip_holder}>
                <Tooltip className={PlanItemMobileStyles.plan_tooltip}>{value.tooltipText}</Tooltip>
              </span>
            )}
          </>
        ))}
      </li>
    ));
  }

  // hide/show sub slider arrows depending on active slide
  trackSubSlideIndex(oldIndex, newIndex) {
    // workaround to prevent delay in slider animation
    setTimeout(() => {
      switch (newIndex) {
        case 2:
          this.setState({
            slideNum: newIndex,
          });
          break;
        case 0:
          this.setState({
            slideNum: newIndex,
          });
          break;
        case 1:
          this.setState({
            slideNum: newIndex,
          });
          break;
        default:
          this.setState({
            slideNum: 1,
          });
          break;
      }
    }, 400);
  }

  render() {
    const {
      images,
      text,
      features,
      basic = false,
      silver = false,
      gold = false,
      openMobilePlanCard,
      userPlan,
      userPlanType,
      current_plan,
      planPriceInfo,
      head_title,
      isUserWithPlan,
      openedPlanInfo,
      activePlane, activePlaneType, isAddOnActive, addOnType,
      updateParentState, onSubscribe, hasInsightsAccess,
      currency,
      currencyShort,
      currencySymbol,
    } = this.props;
    const {
      slideNum,
    } = this.state;

    const {
      smallestPrice,
      largestPrice,
    } = getPriceInfo({
      basic,
      planPriceInfo,
      currency,
    });

    const planImg = cx('plan_img', {
      basic,
      silver,
      gold,
    });

    const pricingPlansInner = cx('pricing_plan_inner', {
      guest: userPlan === GUEST_PLAN,
      'registered-user-plan': isUserWithPlan,
      'user-gold-plan': userPlan === 'gold_plan' && gold,
      'user-silver-plan': userPlan === 'silver_plan' && silver,
      'user-basic-plan': userPlan === 'basic_plan' && basic,
      gold,
      basic,
      silver,
    });

    const planTitleClass = cx('plan_title', {
      'gold-plan-title': gold,
      'basic-plan-title': basic,
      'silver-plan-title': silver,
    });

    const activeFeatures = filter(features, (f) => !f.coming_soon);
    const comingFeatures = filter(features, 'coming_soon');

    const sliderSettings = {
      dots: false,
      arrows: false,
      swipe: false,
      adaptiveHeight: false,
      initialSlide: slideNum,
      infinite: false,
      beforeChange: this.trackSubSlideIndex,
      centerPadding: '60px',
    };

    return (
      <div className={pricingPlansInner}>
        <div
          className={cx('plan-body')}
          id={`${current_plan}-id`}
        >
          {!openedPlanInfo && (
            <PlanItemMobileCard
              images={images}
              planTitleClass={planTitleClass}
              basic={basic}
              gold={gold}
              silver={silver}
              headTitle={head_title}
              planImg={planImg}
              currentPlan={current_plan}
              openMobilePlanCard={openMobilePlanCard}
              text={text}
              smallestPrice={smallestPrice}
              largestPrice={largestPrice}
            />
          )}

          {openedPlanInfo ? (
            <>
              <div className={planImg}>
                <picture className="text-center">
                  <source media="(max-width: 767px)" srcSet={images.smallImg} />
                  <source media="(max-width: 1023px)" srcSet={images.mediumImg} />
                  <img src={images.bigImg} alt="Blue bird" />
                </picture>
              </div>

              <div className={planTitleClass}>
                <h2>{head_title}</h2>
                {basic && <p>{text}</p>}
                {!basic && (
                  <div className={PlanItemMobileStyles['price-start']}>
                    <div className={PlanItemMobileStyles.value}>
                      <span className={PlanItemMobileStyles.cost}>
                        {currencySymbol}
                        {`${smallestPrice}${largestPrice !== smallestPrice ? `-${largestPrice}` : ''}`}
                      </span>
                      &nbsp;
                      {currencyShort}
                      /mo
                    </div>
                    {silver && (
                      <div className={PlanItemMobileStyles['silver-trial-badge']}>
                        FREE trial
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className={PlanItemMobileStyles['mobile-body']}>
                <div className={PlanItemMobileStyles.plan_features}>
                  {silver && (
                    <p className={PlanItemMobileStyles.plan_features_title}>
                      Everything in the BASIC plan plus:
                    </p>
                  )}
                  {gold && (
                    <p className={PlanItemMobileStyles.plan_features_title}>
                      Everything in the SILVER plan plus:
                    </p>
                  )}
                  <ul className={`${PlanItemMobileStyles.plan_features_main} d-flex`}>
                    {this.createListElement(activeFeatures)}
                  </ul>
                  {!basic && (
                    <div className={PlanItemMobileStyles['coming-soon-features']}>
                      <span className={PlanItemMobileStyles['coming-soon-features-title']}>Features Coming Soon:</span>
                      <ul className="d-flex">
                        {this.createListElement(comingFeatures)}
                      </ul>
                    </div>
                  )}
                </div>
                <div className={cx('prices', { 'basic-plan': basic })}>
                  {!basic && (
                    <div>
                      <Dots
                        planPriceInfo={planPriceInfo}
                        setActiveSlide={this.setActiveSlide}
                        slideNum={slideNum}
                      />
                    </div>
                  )}
                  <Slider {...sliderSettings} ref={this.slider}>
                    {Array.isArray(planPriceInfo) && planPriceInfo.map((priceInfo) => (
                      <PricingPlanSubscribeOption
                        key={priceInfo}
                        priceInfo={priceInfo}
                        isUserWithPlan={isUserWithPlan}
                        text={text}
                        currentPlan={current_plan}
                        gold={gold}
                        silver={silver}
                        onSubscribe={onSubscribe}
                        basic={basic}
                        userPlan={userPlan}
                        userPlanType={userPlanType}
                        activePlane={activePlane}
                        activePlaneType={activePlaneType}
                        isAddOnActive={isAddOnActive}
                        addOnType={addOnType}
                        updateParentState={updateParentState}
                        isMobileView
                        hasInsightsAccess={hasInsightsAccess}
                      />
                    ))}
                  </Slider>
                </div>
              </div>
            </>
          ) : null}
        </div>
      </div>
    );
  }
}

const Dots = ({ planPriceInfo, setActiveSlide, slideNum }) => (
  <ul>
    {planPriceInfo.map((plan, index) => (
      <li
        className={cx('sub-slide-dots', { active: slideNum === index })}
        onClick={() => setActiveSlide(index)}
        key={plan.id}
      >
        {plan.billing_period}
        &ensp;
        {plan.billing_period_unit}
      </li>
    ))}
  </ul>
);

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({
    ...authentication,
  }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withComponentName(
    withPriceCurrency(PlanItemMobile),
  ),
);
